import React from 'react';
import { Box, Typography } from '@mui/material';
import { STEP_TYPES } from '../config/workspaceTypes';
import StructuredStep from '../steps/StructuredStep';
import DataViewStep from '../steps/DataViewStep';
import ToolSelectorStep from '../steps/ToolSelectorStep';
import CodeEditorStep from '../steps/CodeEditorStep';
import CodeRunnerStep from '../steps/CodeRunnerStep';
import LogicFormStep from '../steps/LogicFormStep';
import AnalogyStep from '../steps/AnalogyStep';
import StoryStep from '../steps/StoryStep';

// Routes a step config to the right panel component
const StepPanel = ({ stepConfig, itemContext, response, onChange, disabled }) => {
  const props = { config: stepConfig, itemContext, response, onChange, disabled };

  switch (stepConfig.type) {
    case STEP_TYPES.STRUCTURED:
      return <StructuredStep {...props} />;
    case STEP_TYPES.DATA_VIEW:
      return <DataViewStep {...props} />;
    case STEP_TYPES.TOOL_SELECTOR:
      return <ToolSelectorStep {...props} />;
    case STEP_TYPES.CODE_EDITOR:
      return <CodeEditorStep {...props} />;
    case STEP_TYPES.CODE_RUNNER:
      return <CodeRunnerStep {...props} />;
    case STEP_TYPES.LOGIC_FORM:
      return <LogicFormStep {...props} />;
    case STEP_TYPES.ANALOGY:
      return <AnalogyStep {...props} />;
    case STEP_TYPES.STORY:
      return <StoryStep {...props} />;
    default:
      return (
        <Box sx={{ p: 2, border: 1, borderColor: 'error.main', borderRadius: 1 }}>
          <Typography color="error">Unknown step type: {stepConfig.type}</Typography>
        </Box>
      );
  }
};

export default StepPanel;
